import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { XHR_HTTP_CLIENT } from '../utils/xhr-http-client.token';
import { DashboardMediaUploadFailureReport } from './http-logging';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  private http = inject<HttpClient>(XHR_HTTP_CLIENT);


  uploadFile(file: File, messageId: number, requestId: string) {
    const form = new FormData();
    form.append('file', file);

    return this.http.post<any>(
      `${environment.apiHost}/media/${messageId}`,
      form,
      {
        reportProgress: true,
        observe: 'events',
        withCredentials: true,
        headers: { 'X-Request-ID': requestId },
      }
    );
  }

  reportUploadFailure(report: DashboardMediaUploadFailureReport) {
    return this.http.post<void>(
      `${environment.apiHost}/logs/frontend/media-upload-failure`,
      report,
      {
        withCredentials: true,
        headers: { 'X-Request-ID': report.requestId },
      },
    );
  }
}
